import r from "../managers/braze-instance.js";
import W from "./content-cards-provider-factory.js";
export function requestContentCardsRefresh(e, t) {
  if (r.rr()) return W.m().zi(e, t);
}
